module.exports = __webpack_public_path__ + "static/media/marketing-img.5add53f5.png";